import { render } from "./richText.vue?vue&type=template&id=f39e5cfc&scoped=true"
import script from "./richText.vue?vue&type=script&lang=js"
export * from "./richText.vue?vue&type=script&lang=js"

import "./richText.vue?vue&type=style&index=0&id=f39e5cfc&lang=css"
import "./richText.vue?vue&type=style&index=1&id=f39e5cfc&scoped=true&lang=scss"

import exportComponent from "D:\\AllProject\\h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f39e5cfc"]])

export default __exports__